import './style/index.less';
import { h, render } from 'preact';
import App from './components/app';

render(<App />, document.body);



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/index.js
 **/